import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IRulesFormMeta {
    ruleIdentification: FormInputMeta;
    description: FormInputMeta;
    status: FormInputMeta;
    riskLevel: FormInputMeta;

    detected: FormInputMeta;
    for_in_same: FormInputMeta;
    launched: FormInputMeta;
    is: FormInputMeta;
    typeOf: FormInputMeta;
    that: FormInputMeta;
    where: FormInputMeta;
    limitValue: FormInputMeta;
    byDay: FormInputMeta;
    more: FormInputMeta;
    for_in_specific: FormInputMeta;

    schema: any;
}

const rulesFormMeta = {} as IRulesFormMeta;

rulesFormMeta.ruleIdentification = {
    name: "ruleIdentification",
    type: "text",
    label: "Identification Règle",
    placeholder: "Identification Règle",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.description = {
    name: "description",
    type: "textarea",
    label: "Description",
    placeholder: "Description",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.status = {
    name: "status",
    type: "select",
    label: "Statut",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.riskLevel = {
    name: "riskLevel",
    type: "number",
    label: "Niveau Risque",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

rulesFormMeta.detected = {
    name: "detected",
    type: "select",
    label: "Détecté",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.for_in_same = {
    name: "for_in_same",
    type: "select",
    label: "Pour/Dans les même",
    placeholder: "",
    validation: yup.string()
};

rulesFormMeta.launched = {
    name: "launched",
    type: "select",
    label: "Lancé",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.is = {
    name: "is",
    type: "select",
    label: "Est",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.typeOf = {
    name: "typeOf",
    type: "select",
    label: "De Type",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.that = {
    name: "that",
    type: "select",
    label: "De Type",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.where = {
    name: "where",
    type: "select",
    label: "Où",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.limitValue = {
    name: "limitValue",
    type: "number",
    label: "Valeur Limite",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};

rulesFormMeta.byDay = {
    name: "byDay",
    type: "select",
    label: "Par",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.more = {
    name: "more",
    type: "text",
    label: "Plus",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

rulesFormMeta.for_in_specific = {
    name: "for_in_specific",
    type: "select",
    label: "Pour/Dans spécifique",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};


rulesFormMeta.schema = yup.object().shape(getValidationSchema(rulesFormMeta));

export default rulesFormMeta;